import{styled as i}from"@mui/joy";var a=i("div")`
  display: flex;
  gap: 16px;

  & > * {
    flex: 1;
    min-width: 0;
  }
`;export{a as Row};
//# sourceMappingURL=Row.js.map